<template>
  <icon-base :width="21" :height="18">
    <path d="M0 0l21 9-21 9v-7l15-2L0 7z"/>
  </icon-base>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconBase from '@/vue/icons/IconBase.vue'

export default defineComponent({
  name: 'IconSend',
  components: {
    IconBase,
  },
})
</script>
